module.exports = __webpack_public_path__ + "static/media/meet-blueprint-24-25.c59ea589.png";